/* eslint-disable */
import React from 'react'

// Custom
import { useTranslation } from 'react-i18next';

// Types
import { TCustomGFIActionProps } from '@/@types/views/map';

// OL
import { transform as OlTransform } from "ol/proj";

// MUI
import { Streetview as StreetviewIcon } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

const StreetViewListItem = (props: TCustomGFIActionProps) => {

    const { t } = useTranslation();

    const { featureData, handleCloseMenu } = props;

    const handleGoToStreetView = (position: [number, number]) => {
        const positionLonLat = OlTransform(position, 'EPSG:3857', 'EPSG:4326');
        const streetViewUrl = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${positionLonLat[1]},${positionLonLat[0]}`;
        window.open(streetViewUrl, '_blank');
    }

    const handleClick = () => {
        handleGoToStreetView(featureData.position);
        if (handleCloseMenu) {
            handleCloseMenu();
        }
    }

    return (
        <MenuItem
            onClick={handleClick}
        >
            <ListItemIcon>
                <StreetviewIcon color='primary' fontSize='small'/>
            </ListItemIcon>
            <ListItemText>
                {t("buttons.street_view")}
            </ListItemText>
        </MenuItem>
    )

}

export default StreetViewListItem;
